/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OutputOtgShort } from './OutputOtgShort';
import {
    OutputOtgShortFromJSON,
    OutputOtgShortFromJSONTyped,
    OutputOtgShortToJSON,
} from './OutputOtgShort';

/**
 * 
 * @export
 * @interface OutputZoneShort
 */
export interface OutputZoneShort {
    /**
     * 
     * @type {number}
     * @memberof OutputZoneShort
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof OutputZoneShort
     */
    name: string;
    /**
     * 
     * @type {OutputOtgShort}
     * @memberof OutputZoneShort
     */
    otg?: OutputOtgShort;
}

/**
 * Check if a given object implements the OutputZoneShort interface.
 */
export function instanceOfOutputZoneShort(value: object): boolean {
    if (!('id' in value)) return false;
    if (!('name' in value)) return false;
    return true;
}

export function OutputZoneShortFromJSON(json: any): OutputZoneShort {
    return OutputZoneShortFromJSONTyped(json, false);
}

export function OutputZoneShortFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputZoneShort {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'otg': json['otg'] == null ? undefined : OutputOtgShortFromJSON(json['otg']),
    };
}

export function OutputZoneShortToJSON(value?: OutputZoneShort | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'otg': OutputOtgShortToJSON(value['otg']),
    };
}

